import React from 'react';
import PropTypes from 'prop-types';
import assignmentConstants from 'client/Assignments/constants';
import {handleInputChange} from '../../shared/utils';
import createAssignmentStore from '../../CreateAssignment.store';

export default class CreateAssignmentExplanationOptions extends React.Component {
  static propTypes = {
    correctAnswerSetting: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    assignmentType: PropTypes.string
  };

  shouldComponentUpdate(nextProps) {
    return this.props.correctAnswerSetting !== nextProps.correctAnswerSetting;
  }

  handleKeyPress = (e) => {
    if (e.which === 13) {
      // Enter key
      const input = e.target.children[0];
      handleInputChange(input.name, input.value);
    }
  };

  render() {
    const showAfterEachSetting = createAssignmentStore.isAssigningPracticeExam() ? null : (
      <div className='acf__input-wrapper'>
        <div className='acf__radio-input'>
          <label onKeyPress={this.handleKeyPress} tabIndex='0'>
            <input
              checked={
                this.props.correctAnswerSetting ===
                assignmentConstants.explanationSettings.SHOW_AFTER_EACH
              }
              name='correct_answer_setting'
              onChange={this.props.onChange}
              type='radio'
              value={assignmentConstants.explanationSettings.SHOW_AFTER_EACH}
            />
            <span className='fancy-radio' />
            <div className='acf__radio-input-label'>
              After each question
              <span className='acf__radio-input-label--meta'>(least restrictive)</span>
            </div>
          </label>
        </div>
      </div>
    );
    return (
      <div className='acf__options-row'>
        <fieldset className='acf__fieldset'>
          <legend className='acf__fieldset-legend'>Show correct answers and explanations:</legend>
          {showAfterEachSetting}
          <div className='acf__input-wrapper'>
            <div className='acf__radio-input'>
              <label onKeyPress={this.handleKeyPress} tabIndex='0'>
                <input
                  checked={
                    this.props.correctAnswerSetting ===
                    assignmentConstants.explanationSettings.SHOW_AFTER_ALL
                  }
                  name='correct_answer_setting'
                  onChange={this.props.onChange}
                  type='radio'
                  value={assignmentConstants.explanationSettings.SHOW_AFTER_ALL}
                />
                <span className='fancy-radio' />
                <div className='acf__radio-input-label'>
                  After {this.props.assignmentType} completion
                  <span className='acf__radio-input-label--meta'>(moderately restrictive)</span>
                </div>
              </label>
            </div>
          </div>
          <div className='acf__input-wrapper'>
            <div className='acf__radio-input'>
              <label onKeyPress={this.handleKeyPress} tabIndex='0'>
                <input
                  checked={
                    this.props.correctAnswerSetting ===
                    assignmentConstants.explanationSettings.SHOW_AFTER_DUE_DATE
                  }
                  name='correct_answer_setting'
                  onChange={this.props.onChange}
                  type='radio'
                  value={assignmentConstants.explanationSettings.SHOW_AFTER_DUE_DATE}
                />
                <span className='fancy-radio' />
                <div className='acf__radio-input-label'>
                  After due date has passed
                  <span className='acf__radio-input-label--meta'>(most restrictive)</span>
                </div>
              </label>
            </div>
          </div>
        </fieldset>
      </div>
    );
  }
}
